/* DON'T EDIT THIS FILE: edit original and run build again */ import { InvestmentExperienceLevel } from "../../../onboarding/onboarding-section/investment-profile-type/experience-level-type.ts";
import {
  estimatedAmountToInvestCurrencyFieldName,
  estimatedAmountToInvestFieldName,
  howMuchToInvestFieldName,
  investmentExperienceFieldName,
  lossResponseWithdrawFieldName,
  otherSwornStatementFieldName,
  swornStatementAboutLegalityFieldName,
} from "../../../onboarding/onboarding-section/investment-profile-type/field-names-manual.ts";
import {
  ageFieldName,
  desiredProfitabilityFieldName,
  financialKnowledgeFieldName,
  investmentObjectiveFieldName,
  investorRevenueVolumeFieldName,
  riskToleranceFieldName,
  timeInYearsFieldName,
} from "../../../onboarding/onboarding-section/investment-profile-type/field-names-score.ts";
import {
  investmentExperienceLevelFieldName,
  investmentProfileProfileFieldName,
  isQualifiedInvestorFieldName,
  profileAcceptanceFieldName,
  typeOfQualifiedInvestorFieldName,
} from "../../../onboarding/onboarding-section/investment-profile-type/field-names.ts";
import { InvestmentExperienceMap } from "../../../onboarding/onboarding-section/investment-profile-type/investment-experience-type.ts";

export enum InvestmentProfileMethod {
  manual = "manual",
  score = "score",
  none = "none",
}

export type InvestmentProfileMap = {
  profile?: InvestmentProfileResult;
  calculationDate?: string;
  answers?: InvestmentProfileAnswers;
};

export type InvestmentProfileAnswers = ManualAnswers | ScoreAnswers;

export type ManualAnswers = {
  [isQualifiedInvestorFieldName]?: boolean;
  [typeOfQualifiedInvestorFieldName]?: string;
  [investmentExperienceLevelFieldName]?: InvestmentExperienceLevel;
  [investmentProfileProfileFieldName]?: string;
  [lossResponseWithdrawFieldName]?: string;
  [howMuchToInvestFieldName]?: string;
  [investmentExperienceFieldName]?: InvestmentExperienceMap;
  [estimatedAmountToInvestFieldName]?: number;
  [estimatedAmountToInvestCurrencyFieldName]?: string;
  [swornStatementAboutLegalityFieldName]?: Record<string, boolean>;
  [otherSwornStatementFieldName]?: string;
  [profileAcceptanceFieldName]?: boolean;
};

export type ScoreAnswers = {
  [ageFieldName]?: string;
  [timeInYearsFieldName]?: string;
  [investmentObjectiveFieldName]?: string;
  [investorRevenueVolumeFieldName]?: string;
  [riskToleranceFieldName]?: string;
  [financialKnowledgeFieldName]?: string;
  [desiredProfitabilityFieldName]?: string;
  [investmentExperienceLevelFieldName]?: InvestmentExperienceLevel;
  [profileAcceptanceFieldName]?: boolean;
  [isQualifiedInvestorFieldName]?: boolean;
  [typeOfQualifiedInvestorFieldName]?: string;
};

export enum InvestmentProfileResult {
  capitalProtection = "protect",
  capitalGrowth = "grow",
  moderate = "moderate",
  aggressiveCapitalization = "aggressive",
}

export const investmentProfileProfileOptions: Record<
  InvestmentProfileResult,
  string
> = {
  [InvestmentProfileResult.capitalProtection]: "Protección de capital",
  [InvestmentProfileResult.capitalGrowth]: "Crecimiento de capital",
  [InvestmentProfileResult.moderate]: "Moderado",
  [InvestmentProfileResult.aggressiveCapitalization]: "Capitalización agresiva",
};

export const auneInvestmentProfileProfileOptions: Record<
  InvestmentProfileResult,
  string
> = {
  [InvestmentProfileResult.capitalProtection]: "Conservador",
  [InvestmentProfileResult.capitalGrowth]: "Crecimiento",
  [InvestmentProfileResult.moderate]: "Moderado",
  [InvestmentProfileResult.aggressiveCapitalization]: "Agresivo",
};
